import type { FileFormat } from "./types";

export const SUPPORTED_VERSIONS = {
  notification: ["V2.2", "V2.1"],
  impact: ["1.0"],
  notification_decision: ["1.0"],
  risk_analysis: ["v2", "V1.3", "V1.2", "V1.1", "V1.0"],
} as const;

export const FILE_EXTENSION_TO_FORMAT: Record<string, FileFormat> = {
  ".xlsx": "xlsx",
  ".xls": "xlsx",
  ".pdf": "pdf",
};

export const RISK_ANALYSIS_SECTOR_SHEETS = [
  { sheetName: "101_Energie", sectorId: "101", sectorName: "ENERGIE" },
  { sheetName: "102_Transport", sectorId: "102", sectorName: "TRANSPORT" },
  {
    sheetName: "104_Infrastructuri financiare",
    sectorId: "104",
    sectorName: "INFRASTRUCTURI ALE PIEȚEI FINANCIARE",
  },
  {
    sheetName: "105_Sanatate",
    sectorId: "105",
    sectorName: "SECTORUL SĂNĂTĂȚII",
  },
  {
    sheetName: "106_Apa potabila",
    sectorId: "106",
    sectorName: "APĂ POTABILĂ",
  },
  { sheetName: "107_Ape uzate", sectorId: "107", sectorName: "APE UZATE" },
  {
    sheetName: "108_Infrastructura digitala",
    sectorId: "108",
    sectorName: "INFRASTRUCTURĂ DIGITALĂ",
  },
  {
    sheetName: "109_Gestionare servicii TIC",
    sectorId: "109",
    sectorName: "GESTIONAREA SERVICIILOR TIC (B2B)",
  },
  {
    sheetName: "110_Administratie publica",
    sectorId: "110",
    sectorName: "ADMINISTRAȚIE PUBLICĂ",
  },
  { sheetName: "111_Spatiu", sectorId: "111", sectorName: "SPAȚIU" },
  {
    sheetName: "201_Servicii poștale",
    sectorId: "201",
    sectorName: "SERVICII POȘTALE ȘI DE CURIERAT",
  },
  {
    sheetName: "202_Gestionarea deseurilor",
    sectorId: "202",
    sectorName: "GESTIONAREA DEȘEURILOR",
  },
  {
    sheetName: "203_Substante chimice",
    sectorId: "203",
    sectorName: "FABRICAREA, PRODUCȚIA ȘI DISTRIBUȚIA DE SUBSTANȚE CHIMICE",
  },
  {
    sheetName: "204_Alimente",
    sectorId: "204",
    sectorName: "PRODUCȚIA, PRELUCRAREA ȘI/SAU DISTRIBUȚIA DE ALIMENTE",
  },
  { sheetName: "205_Fabricare", sectorId: "205", sectorName: "FABRICARE" },
  {
    sheetName: "206_Furnizori digitali",
    sectorId: "206",
    sectorName: "FURNIZORI DIGITALI",
  },
  { sheetName: "207_Cercetare", sectorId: "207", sectorName: "CERCETARE" },
] as const;

export type NotificationServiceRow = {
  row: number;
  entityId: string;
  label: string;
  categoryId: "1" | "2";
  sectorName: string;
  subsectorName: string | null;
};

export const NOTIFICATION_SERVICE_ROWS: NotificationServiceRow[] = [
  // SECTOARE CU O IMPORTANȚĂ CRITICĂ RIDICATĂ (Category 1)
  // ENERGIE - Electricitate
  {
    row: 31,
    entityId: "101101",
    label: "Furnizori de energie electrică",
    categoryId: "1",
    sectorName: "ENERGIE",
    subsectorName: "Electricitate",
  },
  {
    row: 32,
    entityId: "101102",
    label: "Operatori de distribuție energie electrică",
    categoryId: "1",
    sectorName: "ENERGIE",
    subsectorName: "Electricitate",
  },
  {
    row: 33,
    entityId: "101103",
    label: "Operatori de transport și de sistem energie electrică",
    categoryId: "1",
    sectorName: "ENERGIE",
    subsectorName: "Electricitate",
  },
  {
    row: 34,
    entityId: "101104",
    label: "Producători energie electrică",
    categoryId: "1",
    sectorName: "ENERGIE",
    subsectorName: "Electricitate",
  },
  {
    row: 35,
    entityId: "101105",
    label: "Operatori desemnați ai pieței de energie electrică",
    categoryId: "1",
    sectorName: "ENERGIE",
    subsectorName: "Electricitate",
  },
  {
    row: 36,
    entityId: "101106",
    label: "Participanții la piața de energie electrică",
    categoryId: "1",
    sectorName: "ENERGIE",
    subsectorName: "Electricitate",
  },
  {
    row: 37,
    entityId: "101107",
    label: "Operatori ai unui punct de reîncărcare",
    categoryId: "1",
    sectorName: "ENERGIE",
    subsectorName: "Electricitate",
  },
  {
    row: 38,
    entityId: "101108",
    label:
      "Operatori economici, concesionarii și dezvoltatorul centralei electrice eoliene offshore",
    categoryId: "1",
    sectorName: "ENERGIE",
    subsectorName: "Electricitate",
  },
  // ENERGIE - Încălzire/răcire centralizată
  {
    row: 40,
    entityId: "101201",
    label: "Operatorii de încălzire sau răcire centralizată",
    categoryId: "1",
    sectorName: "ENERGIE",
    subsectorName: "Încălzire centralizată și răcire centralizată",
  },
  // ENERGIE - Petrol
  {
    row: 42,
    entityId: "101301",
    label: "Operatori de conducte de transport al petrolului",
    categoryId: "1",
    sectorName: "ENERGIE",
    subsectorName: "Petrol",
  },
  {
    row: 43,
    entityId: "101302",
    label:
      "Operatori instalații de producție, de rafinare și de tratare a petrolului, de depozitare și de transport",
    categoryId: "1",
    sectorName: "ENERGIE",
    subsectorName: "Petrol",
  },
  {
    row: 44,
    entityId: "101303",
    label: "Entități centrale de stocare",
    categoryId: "1",
    sectorName: "ENERGIE",
    subsectorName: "Petrol",
  },
  // ENERGIE - Gaze
  {
    row: 46,
    entityId: "101401",
    label: "Întreprinderi de furnizare gaze naturale",
    categoryId: "1",
    sectorName: "ENERGIE",
    subsectorName: "Gaze",
  },
  {
    row: 47,
    entityId: "101402",
    label: "Operatori de distribuție gaze naturale",
    categoryId: "1",
    sectorName: "ENERGIE",
    subsectorName: "Gaze",
  },
  {
    row: 48,
    entityId: "101403",
    label: "Operatori de transport și de sistem gaze naturale",
    categoryId: "1",
    sectorName: "ENERGIE",
    subsectorName: "Gaze",
  },
  {
    row: 49,
    entityId: "101404",
    label: "Operatori de înmagazinare gaze naturale",
    categoryId: "1",
    sectorName: "ENERGIE",
    subsectorName: "Gaze",
  },
  {
    row: 50,
    entityId: "101405",
    label: "Operatori de sistem GNL",
    categoryId: "1",
    sectorName: "ENERGIE",
    subsectorName: "Gaze",
  },
  {
    row: 51,
    entityId: "101406",
    label: "Întreprinderi din sectorul gazelor naturale",
    categoryId: "1",
    sectorName: "ENERGIE",
    subsectorName: "Gaze",
  },
  {
    row: 52,
    entityId: "101407",
    label:
      "Operatori de instalație de rafinare și de tratare a gazelor naturale",
    categoryId: "1",
    sectorName: "ENERGIE",
    subsectorName: "Gaze",
  },
  // ENERGIE - Hidrogen
  {
    row: 54,
    entityId: "101501",
    label: "Operatori de producție, stocare și transport de hidrogen",
    categoryId: "1",
    sectorName: "ENERGIE",
    subsectorName: "Hidrogen",
  },
  // ENERGIE - Fonduri
  {
    row: 56,
    entityId: "101601",
    label:
      "Beneficiarii prevăzuți de OUG nr. 60/2022 - Fondul pentru modernizare",
    categoryId: "1",
    sectorName: "ENERGIE",
    subsectorName:
      "Beneficiarii proiectelor finanțate din fonduri nerambursabile",
  },
  // TRANSPORT - Aerian
  {
    row: 59,
    entityId: "102101",
    label: "Transportatori aerieni",
    categoryId: "1",
    sectorName: "TRANSPORT",
    subsectorName: "Transport aerian",
  },
  {
    row: 60,
    entityId: "102102",
    label:
      "Organe de administrare a aeroporturilor și aeroporturile, inclusiv entitățile care operează instalații auxiliare în cadrul aeroporturilor",
    categoryId: "1",
    sectorName: "TRANSPORT",
    subsectorName: "Transport aerian",
  },
  {
    row: 61,
    entityId: "102103",
    label:
      "Operatori de control al gestionării traficului care prestează servicii de control al traficului aerian (ATC)",
    categoryId: "1",
    sectorName: "TRANSPORT",
    subsectorName: "Transport aerian",
  },
  {
    row: 62,
    entityId: "102104",
    label: "Operatori mentenanță aeronave",
    categoryId: "1",
    sectorName: "TRANSPORT",
    subsectorName: "Transport aerian",
  },
  {
    row: 63,
    entityId: "102105",
    label: "Agenți aeronautici civili",
    categoryId: "1",
    sectorName: "TRANSPORT",
    subsectorName: "Transport aerian",
  },
  {
    row: 64,
    entityId: "102106",
    label:
      "Organizații menționate la art. 2 alin. (1) din Regulamentul delegat (UE) 2022/1645",
    categoryId: "1",
    sectorName: "TRANSPORT",
    subsectorName: "Transport aerian",
  },
  {
    row: 65,
    entityId: "102107",
    label:
      "Organizații menționate la art. 2 alin. (1) din Regulamentul de punere în aplicare (UE) 2023/203",
    categoryId: "1",
    sectorName: "TRANSPORT",
    subsectorName: "Transport aerian",
  },
  // TRANSPORT - Feroviar
  {
    row: 67,
    entityId: "102201",
    label: "Administratorii infrastructurii feroviare",
    categoryId: "1",
    sectorName: "TRANSPORT",
    subsectorName: "Transport feroviar",
  },
  {
    row: 68,
    entityId: "102202",
    label: "Întreprinderi feroviare",
    categoryId: "1",
    sectorName: "TRANSPORT",
    subsectorName: "Transport feroviar",
  },
  // TRANSPORT - Apă
  {
    row: 70,
    entityId: "102301",
    label:
      "Companii de transport de mărfuri și pasageri pe ape interioare, maritime și de coastă",
    categoryId: "1",
    sectorName: "TRANSPORT",
    subsectorName: "Transport pe apă",
  },
  {
    row: 71,
    entityId: "102302",
    label:
      "Organe de gestionare a porturilor și entitățile care realizează lucrări și operează echipamente în cadrul porturilor",
    categoryId: "1",
    sectorName: "TRANSPORT",
    subsectorName: "Transport pe apă",
  },
  {
    row: 72,
    entityId: "102303",
    label: "Operatori de servicii de trafic maritim (STM)",
    categoryId: "1",
    sectorName: "TRANSPORT",
    subsectorName: "Transport pe apă",
  },
  // TRANSPORT - Rutier
  {
    row: 74,
    entityId: "102401",
    label: "Autorități rutiere",
    categoryId: "1",
    sectorName: "TRANSPORT",
    subsectorName: "Transport rutier",
  },
  {
    row: 75,
    entityId: "102402",
    label: "Operatorii de sisteme de transport inteligente",
    categoryId: "1",
    sectorName: "TRANSPORT",
    subsectorName: "Transport rutier",
  },
  // TRANSPORT - Public
  {
    row: 77,
    entityId: "102501",
    label: "Operatorii de servicii publice",
    categoryId: "1",
    sectorName: "TRANSPORT",
    subsectorName: "Transport public",
  },
  // SECTORUL BANCAR
  {
    row: 79,
    entityId: "103001",
    label: "Instituții de credit",
    categoryId: "1",
    sectorName: "SECTORUL BANCAR",
    subsectorName: null,
  },
  // INFRASTRUCTURI ALE PIEȚEI FINANCIARE
  {
    row: 81,
    entityId: "104001",
    label: "Operatori de locuri de tranzacționare",
    categoryId: "1",
    sectorName: "INFRASTRUCTURI ALE PIEȚEI FINANCIARE",
    subsectorName: null,
  },
  {
    row: 82,
    entityId: "104002",
    label: "Contrapărți centrale (CPC)",
    categoryId: "1",
    sectorName: "INFRASTRUCTURI ALE PIEȚEI FINANCIARE",
    subsectorName: null,
  },
  {
    row: 83,
    entityId: "104003",
    label:
      "Instituții care asigură efectuarea operațiunilor de încasări și plăți privind fondurile publice",
    categoryId: "1",
    sectorName: "INFRASTRUCTURI ALE PIEȚEI FINANCIARE",
    subsectorName: null,
  },
  // SECTORUL SĂNĂTĂȚII
  {
    row: 85,
    entityId: "105001",
    label: "Furnizori de servicii medicale",
    categoryId: "1",
    sectorName: "SECTORUL SĂNĂTĂȚII",
    subsectorName: null,
  },
  {
    row: 86,
    entityId: "105002",
    label: "Laboratoare de referință ale UE",
    categoryId: "1",
    sectorName: "SECTORUL SĂNĂTĂȚII",
    subsectorName: null,
  },
  {
    row: 87,
    entityId: "105003",
    label:
      "Entități care desfășoară activități de cercetare și dezvoltare a medicamentelor",
    categoryId: "1",
    sectorName: "SECTORUL SĂNĂTĂȚII",
    subsectorName: null,
  },
  {
    row: 88,
    entityId: "105004",
    label:
      "Entităție care fabrică produse farmaceutice de bază și preparate farmaceutice",
    categoryId: "1",
    sectorName: "SECTORUL SĂNĂTĂȚII",
    subsectorName: null,
  },
  {
    row: 89,
    entityId: "105005",
    label:
      "Entități care fabrică dispozitive medicale considerate a fi esențiale în contextul unei urgențe de sănătate publică",
    categoryId: "1",
    sectorName: "SECTORUL SĂNĂTĂȚII",
    subsectorName: null,
  },
  {
    row: 90,
    entityId: "105006",
    label:
      "Entități titulare ale unei autorizații de distribuție a medicamentelor",
    categoryId: "1",
    sectorName: "SECTORUL SĂNĂTĂȚII",
    subsectorName: null,
  },
  {
    row: 91,
    entityId: "105007",
    label:
      "Întreprinderilare desfășoară oricare din activitățile economice din CAEN 4646 și 4773 (Rev3)",
    categoryId: "1",
    sectorName: "SECTORUL SĂNĂTĂȚII",
    subsectorName: null,
  },
  // APĂ POTABILĂ
  {
    row: 93,
    entityId: "106001",
    label: "Furnizori și distribuitori de apă destinată consumului uman",
    categoryId: "1",
    sectorName: "APĂ POTABILĂ",
    subsectorName: null,
  },
  // APE UZATE
  {
    row: 95,
    entityId: "107001",
    label:
      "Întreprinderi care colectează, evacuează sau tratează ape urbane reziduale, ape menajere uzate sau ape industriale uzate",
    categoryId: "1",
    sectorName: "APE UZATE",
    subsectorName: null,
  },
  // INFRASTRUCTURĂ DIGITALĂ
  {
    row: 97,
    entityId: "108001",
    label: "Furnizori de IXP (internet exchange point)",
    categoryId: "1",
    sectorName: "INFRASTRUCTURĂ DIGITALĂ",
    subsectorName: null,
  },
  {
    row: 98,
    entityId: "108002",
    label:
      "Furnizori de servicii DNS, cu excepția operatorilor de servere pentru nume primare",
    categoryId: "1",
    sectorName: "INFRASTRUCTURĂ DIGITALĂ",
    subsectorName: null,
  },
  {
    row: 99,
    entityId: "108003",
    label: "Registre de nume TLD",
    categoryId: "1",
    sectorName: "INFRASTRUCTURĂ DIGITALĂ",
    subsectorName: null,
  },
  {
    row: 100,
    entityId: "108004",
    label: "Furnizori de servicii de cloud computing",
    categoryId: "1",
    sectorName: "INFRASTRUCTURĂ DIGITALĂ",
    subsectorName: null,
  },
  {
    row: 101,
    entityId: "108005",
    label: "Furnizori de servicii de centre de date",
    categoryId: "1",
    sectorName: "INFRASTRUCTURĂ DIGITALĂ",
    subsectorName: null,
  },
  {
    row: 102,
    entityId: "108006",
    label: "Furnizorii de rețele de difuzare de conținut",
    categoryId: "1",
    sectorName: "INFRASTRUCTURĂ DIGITALĂ",
    subsectorName: null,
  },
  {
    row: 103,
    entityId: "108007",
    label: "Prestatorii de servicii de încredere necalificați",
    categoryId: "1",
    sectorName: "INFRASTRUCTURĂ DIGITALĂ",
    subsectorName: null,
  },
  {
    row: 104,
    entityId: "108008",
    label: "Prestatorii de servicii de încredere calificați",
    categoryId: "1",
    sectorName: "INFRASTRUCTURĂ DIGITALĂ",
    subsectorName: null,
  },
  {
    row: 105,
    entityId: "108009",
    label: "Furnizori de rețele publice de comunicații electronice",
    categoryId: "1",
    sectorName: "INFRASTRUCTURĂ DIGITALĂ",
    subsectorName: null,
  },
  {
    row: 106,
    entityId: "108010",
    label:
      "Furnizori de servicii de comunicații electronice accesibile publicului",
    categoryId: "1",
    sectorName: "INFRASTRUCTURĂ DIGITALĂ",
    subsectorName: null,
  },
  // GESTIONAREA SERVICIILOR TIC (B2B)
  {
    row: 108,
    entityId: "109001",
    label: "Furnizori de servicii gestionate",
    categoryId: "1",
    sectorName: "GESTIONAREA SERVICIILOR TIC (BUSINESS-TO-BUSINESS)",
    subsectorName: null,
  },
  {
    row: 109,
    entityId: "109002",
    label: "Furnizori de servicii de securitate gestionate",
    categoryId: "1",
    sectorName: "GESTIONAREA SERVICIILOR TIC (BUSINESS-TO-BUSINESS)",
    subsectorName: null,
  },
  // ADMINISTRAȚIE PUBLICĂ
  {
    row: 111,
    entityId: "110001",
    label: "Entitățile administrației publice centrale",
    categoryId: "1",
    sectorName: "ADMINISTRAȚIE PUBLICĂ",
    subsectorName: null,
  },
  // SPAȚIU
  {
    row: 113,
    entityId: "111001",
    label:
      "Operatori de infrastructură terestră deținută, gestionată și operată care sprijină furnizarea de servicii spațiale",
    categoryId: "1",
    sectorName: "SPAȚIU",
    subsectorName: null,
  },
  // ALTE SECTOARE DE IMPORTANȚĂ CRITICĂ (Category 2)
  // SERVICII POȘTALE ȘI DE CURIERAT
  {
    row: 116,
    entityId: "201001",
    label:
      "Furnizorii de servicii poștale, inclusiv furnizori de servicii de curierat",
    categoryId: "2",
    sectorName: "SERVICII POȘTALE ȘI DE CURIERAT",
    subsectorName: null,
  },
  // GESTIONAREA DEȘEURILOR
  {
    row: 118,
    entityId: "202001",
    label: "Întreprinderi care efectuează gestionarea deșeurilor",
    categoryId: "2",
    sectorName: "GESTIONAREA DEȘEURILOR",
    subsectorName: null,
  },
  // SUBSTANȚE CHIMICE
  {
    row: 120,
    entityId: "203001",
    label:
      "Întreprinderile care produc substanțe și distribuie substanțe sau amestecuri, precum și care produc articole din substanțe sau amestecuri",
    categoryId: "2",
    sectorName: "FABRICAREA, PRODUCȚIA ȘI DISTRIBUȚIA DE SUBSTANȚE CHIMICE",
    subsectorName: null,
  },
  // ALIMENTE
  {
    row: 122,
    entityId: "204001",
    label: "Întreprinderile cu profil alimentar",
    categoryId: "2",
    sectorName: "PRODUCȚIA, PRELUCRAREA ȘI/SAU DISTRIBUȚIA DE ALIMENTE",
    subsectorName: null,
  },
  // FABRICARE
  {
    row: 125,
    entityId: "205101",
    label: "Entități care fabrică dispozitive medicale",
    categoryId: "2",
    sectorName: "FABRICARE",
    subsectorName:
      "Fabricarea de dispozitive medicale și de dispozitive medicale pentru diagnostic in vitro",
  },
  {
    row: 127,
    entityId: "205201",
    label:
      "Întreprinderi care desfășoară oricare dintre activitățile economice (Secțiunea CAEN 26)",
    categoryId: "2",
    sectorName: "FABRICARE",
    subsectorName:
      "Fabricarea computerelor și a produselor electronice și optice",
  },
  {
    row: 129,
    entityId: "205301",
    label:
      "Întreprinderi care desfășoară oricare dintre activitățile economice (Secțiunea CAEN 27)",
    categoryId: "2",
    sectorName: "FABRICARE",
    subsectorName: "Fabricarea echipamentelor electrice",
  },
  {
    row: 131,
    entityId: "205401",
    label:
      "Întreprinderi care desfășoară oricare dintre activitățile economice (Secțiunea CAEN 28)",
    categoryId: "2",
    sectorName: "FABRICARE",
    subsectorName: "Fabricarea altor mașini și echipamente n.c.a.",
  },
  {
    row: 133,
    entityId: "205501",
    label:
      "Întreprinderi care desfășoară oricare dintre activitățile economice (Secțiunea CAEN 29)",
    categoryId: "2",
    sectorName: "FABRICARE",
    subsectorName: "Fabricarea autovehiculelor, remorcilor și semiremorcilor",
  },
  {
    row: 135,
    entityId: "205601",
    label:
      "Întreprinderi care desfășoară oricare dintre activitățile economice (Secțiunea CAEN 30)",
    categoryId: "2",
    sectorName: "FABRICARE",
    subsectorName: "Fabricarea altor echipamente de transport",
  },
  // FURNIZORI DIGITALI
  {
    row: 137,
    entityId: "206001",
    label: "Furnizori de piețe online",
    categoryId: "2",
    sectorName: "FURNIZORI DIGITALI",
    subsectorName: null,
  },
  {
    row: 138,
    entityId: "206002",
    label: "Furnizori de motoare de căutare online",
    categoryId: "2",
    sectorName: "FURNIZORI DIGITALI",
    subsectorName: null,
  },
  {
    row: 139,
    entityId: "206003",
    label: "Furnizori de platforme de servicii de socializare în rețea",
    categoryId: "2",
    sectorName: "FURNIZORI DIGITALI",
    subsectorName: null,
  },
  // CERCETARE
  {
    row: 141,
    entityId: "207001",
    label: "Organizațiile de cercetare",
    categoryId: "2",
    sectorName: "CERCETARE",
    subsectorName: null,
  },
];

export const NOTIFICATION_NONE_SERVICE_ROW = 142;

export const RISK_ANALYSIS_ACTOR_NAMES = [
  "Competitori ostili",
  "Activiști motivați ideologic",
  "Teroriști",
  "Infractori cibernetici",
  "Actori statali",
] as const;

export const ACTOR_NAME_TO_KEY: Record<string, string> = {
  "Competitori ostili": "competitori",
  "Activiști motivați ideologic": "activisti",
  Teroriști: "teroristi",
  "Infractori cibernetici": "infractori",
  "Actori statali": "actori",
};

export const RISK_ANALYSIS_ATTACK_CATEGORIES = [
  "Sabotaj/perturbare a furnizării serviciului",
  "Furtul de informații/spionaj",
  "Atacuri specifice criminalității cibernetice",
  "Hacktivism/vandalism cibernetic",
  "Atacuri care țintesc sau care afectează imaginea entității",
] as const;
